import React, { useEffect, useState } from 'react';
import { Pie } from 'react-chartjs-2';
import { collection, query, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';

import { Chart, BarController, CategoryScale, LinearScale, BarElement, PieController } from 'chart.js';

Chart.register(BarController, CategoryScale, LinearScale, BarElement, PieController);

const FeedBackStats = () => {
    const [feedbackData, setFeedbackData] = useState({
        open: 0,
        closed: 0
    });

    useEffect(() => {
        const fetchFeedback = async () => {
            const q = query(collection(db, "feedbacks"));
            const querySnapshot = await getDocs(q);
            let openCount = 0;
            let closedCount = 0;

            querySnapshot.forEach((doc) => {
                const data = doc.data();
                if (data.status === 'Open') openCount++;
                if (data.status === 'Resolved') closedCount++;
            });

            setFeedbackData({ Open: openCount, Resolved: closedCount });
        };

        fetchFeedback();
    }, []);

    const data = {
        labels: ['Open', 'Closed'],
        datasets: [
            {
                label: '# of Votes',
                data: [feedbackData.Open, feedbackData.Resolved],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
            },
        ],
    };
    
    const options = {
        plugins: {
            legend: {
                display: true, // Display the legend
                position: 'top', // Position of the legend
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        let label = context.label || '';
                        if (label) {
                            label += ': ';
                        }
                        label += context.parsed.y;
                        return label;
                    }
                }
            }
        },
    };
   
    

    return (
        <div>
            <div className="mb-6">
                <div className="flex items-center mb-4">
                    <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl flex items-center justify-center mr-3">
                        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z" />
                        </svg>
                    </div>
                    <h2 className='text-lg font-bold text-gray-900'>Status Overview</h2>
                </div>

                {/* Stats Cards */}
                <div className="space-y-3 mb-6">
                    <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl p-4 border border-red-100">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-xs font-medium text-red-700 uppercase mb-1">Open Cases</p>
                                <p className="text-2xl font-bold text-red-600">{feedbackData.Open || 0}</p>
                            </div>
                            <div className="w-12 h-12 bg-red-100 rounded-xl flex items-center justify-center">
                                <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>

                    <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-4 border border-green-100">
                        <div className="flex items-center justify-between">
                            <div>
                                <p className="text-xs font-medium text-green-700 uppercase mb-1">Resolved</p>
                                <p className="text-2xl font-bold text-green-600">{feedbackData.Resolved || 0}</p>
                            </div>
                            <div className="w-12 h-12 bg-green-100 rounded-xl flex items-center justify-center">
                                <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Chart */}
            <div className="bg-gradient-to-br from-gray-50 to-slate-50 rounded-xl p-4">
                <Pie data={data} options={options} />
            </div>
        </div>
    );
};

export default FeedBackStats;
